import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import ApplicationRoutes from "./Application/Router";
import StylesSheet from "../pages/styles";
import Home from "./Home";
import Approved from "../pages/landing/Approved";
import RenewApproval from "../pages/landing/RenewApproval";
import InstantCash from "../pages/landing/InstantCash";
import CashFast from "../pages/landing/CashFast";
import Preapproved from "../pages/landing/Preapproved";

const Routes = () => {
  return (
    <Router>
      <Switch>
        <Route path="/styles" component={StylesSheet} />
        <Route path="/application" component={ApplicationRoutes} />
        {/* `exact` matters here: without it /landing swallows every /landing-* sibling */}
        <Route exact path="/landing" component={Approved} />
        <Route exact path="/landing-2" component={RenewApproval} />
        <Route exact path="/landing-3" component={InstantCash} />
        <Route exact path="/landing-4" component={CashFast} />
        <Route exact path="/landing-5" component={Preapproved} />
        <Route path="/" component={Home} />
      </Switch>
    </Router>
  );
};

export default Routes;
